'use client';
import { useState } from "react";
import { motion } from "framer-motion";
import { LoaderCircle, MessageCircle } from "lucide-react";
import { useT } from "../../i18n";
import { sendTrack } from "../../lib/track";
import { SectionKicker } from "./shared";

export function ActFour() {
  const t = useT();
  const [loading, setLoading] = useState(false);

  const openWhatsApp = () => {
    if (loading) return;
    setLoading(true);
    sendTrack({ event: 'whatsapp_click', page: '/landlink' });
    setTimeout(() => {
      window.location.href = `https://wa.me/85251651480?text=${encodeURIComponent(
        t('landlink.four.waPrefill')
      )}`;
    }, 500);
  };

  return (
    <motion.section
      className="act act-four"
      initial={{ opacity: 0, x: "12%" }}
      animate={{ opacity: 1, x: 0 }}
      exit={{ opacity: 0, x: "-10%", filter: "blur(8px)" }}
      transition={{ duration: 0.6 }}
    >
      <div className="act-bg" />
      <div className="shade" />
      <div className="grain" />

      <div className="act-content">
        <div className="final-content">
          <SectionKicker>{t('landlink.four.kicker')}</SectionKicker>
          <h2>
            {t('landlink.four.titlePre')}
            <br />
            {t('landlink.four.titleMid')}<span>{t('landlink.four.titleHighlight')}</span>{t('landlink.four.titlePost')}
          </h2>
          <p className="body-text">{t('landlink.four.body')}</p>

          <div className="cta-wrap final-cta">
            <button onClick={openWhatsApp} disabled={loading}>
              {loading ? <LoaderCircle className="spin" /> : <MessageCircle fill="currentColor" />}
              {loading ? t('landlink.four.ctaLoading') : t('landlink.four.cta')}
            </button>
            <p>{t('landlink.four.note')}</p>
          </div>
        </div>
      </div>
    </motion.section>
  );
}
